import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface IState {
	selectedRow?: string
}

const initialState = {
	selectedRow: undefined,
}

const customerEmissionRequestSlice = createSlice({
	name: 'customerEmissionRequest',
	initialState,
	reducers: {
		setSelectedRow: (
			state: IState,
			action: PayloadAction<string | undefined>
		) => {
			state.selectedRow = action.payload
		},
	},
})

export default customerEmissionRequestSlice.reducer
